(function () {
  'use strict';
  svgedit.history = svgedit.history || {};

  svgedit.history.BatchCommand = function (text) {
    this.text = text || 'Batch Command';
    this.stack = [];
  };
  svgedit.history.BatchCommand.type = function () { return 'svgedit.history.BatchCommand'; };
  svgedit.history.BatchCommand.prototype.type = svgedit.history.BatchCommand.type;

  svgedit.history.BatchCommand.prototype.getText = function () {
    return this.text;
  };

  svgedit.history.BatchCommand.prototype.apply = function (handler) {
    var stack;
    for (var i = 0, len = this.stack.length; i < len; ++i) {
      if (this.stack[i] instanceof svgedit.history.ChangeElementCommand
                && this.stack[i].elem
                && typeof (svgedit.select.getSelectorManager().selectorMap[this.stack[i].elem.id]) === 'object') {
        stack = this.stack[i];
      }

      this.stack[i].apply(handler);
    }

    if (stack) {
      svgedit.select.getSelectorManager().requestSelector(stack.elem).resize();
      stack.svgCanvas.runExtensions('selectedChanged', {
        elems: [this.elem]
      });
    }

    handler && handler.handleHistoryEvent(svgedit.history.HistoryEventTypes.AFTER_APPLY, this);
  };

  svgedit.history.BatchCommand.prototype.unapply = function (handler) {
    var stack;
    for (var i = this.stack.length - 1; i >= 0; i--) {
      if (this.stack[i] instanceof svgedit.history.ChangeElementCommand
                && this.stack[i].elem
                && typeof (svgedit.select.getSelectorManager().selectorMap[this.stack[i].elem.id]) === 'object') {
        stack = this.stack[i];
      }

      this.stack[i].unapply(handler);
    }

    if (stack) {
      svgedit.select.getSelectorManager().requestSelector(stack.elem).resize();
      stack.svgCanvas.runExtensions('selectedChanged', {
        elems: [this.elem]
      });
    }

    handler && handler.handleHistoryEvent(svgedit.history.HistoryEventTypes.AFTER_UNAPPLY, this);
  };

  svgedit.history.BatchCommand.prototype.elements = function () {
    var elems = [];
    var cmd = this.stack.length;

    while (cmd--) {
      var thisElems = this.stack[cmd].elements();
      var elem = thisElems.length;
      while (elem--) {
        if (elems.indexOf(thisElems[elem]) == -1) { elems.push(thisElems[elem]); }
      }
    }

    return elems;
  };

  svgedit.history.BatchCommand.prototype.addSubCommand = function (cmd) {
    this.stack.push(cmd);
  };

  svgedit.history.BatchCommand.prototype.isEmpty = function () {
    return this.stack.length === 0;
  };
})();
